/**
 * Formats year, make, and model for display, replacing null/undefined values with em-dashes
 */
export const formatYmm = (
  year: string | null | undefined,
  make: string | null | undefined,
  model: string | null | undefined,
): string => {
  const formatValue = (value: string | null | undefined) => value ?? '—';
  return `${formatValue(year)} ${formatValue(make)} ${formatValue(model)}`;
};
